<template>
  <teleport :to="placementId">
    <newsletter-signup
      class="text-media__newsletter-form"
      :custom-source="liquid.handle"
      is-teaser-page
      :namespace="liquid.id"
    />
  </teleport>
</template>

<script>

/**
 * Vue: Text & media (text-media)
 * -----------------------------------------------------------------------------
 * Text and media section used on the pages template.
 * - Limited interactivity liquid.
 *
 * @param {String} liquid - Shopify liquid settings.
 */

import NewsletterSignup from '~async/newsletter-signup/newsletter-signup'

export default {
  name: 'TextMedia',

  components: {
    NewsletterSignup,
  },

  props: {
    liquid: {
      type: Object,
      default: () => ({
        handle: '',
        id: '',
        newsletterData: {
          copy: '',
          title: '',
        },
      }),
    },
  },

  computed: {

    /**
     * Return the id of the element to which the newsletter-signup component
     * will teleport.
     * @returns {String}
     */
    placementId() {
      return `#text-media-newsletter--${this.liquid.id}`
    },
  },
}
</script>

<style lang="scss">
@import './text-media';
</style>
